import { RouteVia } from "../../../../enums/routeVia";

export const isRouteViaCMM = (routeVia: string): boolean =>
  routeVia === RouteVia.CMM;
